import PropTypes from 'prop-types';

import DictionaryForm from './DictionaryForm';
import PluginForm from './PluginForm';
import { EXTENSION_TYPES } from '../../../constants/extensionConstants';

const AddForm = ({ extensionType, ...restProps }) => {
  return extensionType === EXTENSION_TYPES.SOLR_PLUGIN ? (
    <PluginForm extensionType={extensionType} {...restProps} />
  ) : (
    <DictionaryForm extensionType={extensionType} {...restProps} />
  );
};

AddForm.propTypes = {
  extensionType: PropTypes.string.isRequired,
};
export default AddForm;
